import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { CampaignSurvey } from './models/campaign-survey';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

// tracking keywords are a list on the api, while this app edits them in a single text field
type CampaignSurveyPayload = Omit<CampaignSurvey, 'additionalProducts'> & { additionalProducts: string[] };

@Injectable()
export class OnboardingService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.baseUrl;
  }

  businessProfileExists(url: string) {
    var params = { url: url };
    return this.http.get<boolean>(`${this.baseUrl}onboarding/businessprofile/exists`, { params: params });
  }

  isCampaignSurveyComplete(accountId: number) {
    return this.http.get<boolean>(`${this.baseUrl}onboarding/campaignsurvey/iscomplete/${accountId}`);
  }

  getCampaignSurvey(accountId: number) {
    return this.http.get<CampaignSurveyPayload>(`${this.baseUrl}onboarding/campaignsurvey/${accountId}`)
      .pipe(map(survey => ({ ...survey, additionalProducts: (survey.additionalProducts ?? []).join(', ') } as CampaignSurvey)));
  }

  credentialsExists(accountId: number) {
    return this.http.get<boolean>(`${this.baseUrl}onboarding/credentials/has-required/${accountId}`);
  }

  credentialsProvided(accountId: number) {
    return this.http.post<any>(`${this.baseUrl}onboarding/credentials/provided`, { accountId: accountId });
  }

  saveCampaignSurvey(accountId: number, survey: CampaignSurvey) {
    const payload: CampaignSurveyPayload = {
      ...survey,
      additionalProducts: (survey.additionalProducts ?? '').split(',').map(x => x.trim()).filter(x => !!x)
    };

    return this.http.post<any>(`${this.baseUrl}onboarding/campaignsurvey`, { accountId: accountId, campaignSurvey: payload });
  }
}
